import React from "react";
import { AmountBox } from "../../style";
import { formatDateInNumbers } from "../../../../../../../lib/normalizeDate";
import { convertRialToToman } from "../../../../../../../lib/convertRialToToman";

export const FormTexts = props => {
  const calculatePriceData = props.calculatePriceData;
  return (
    <React.Fragment>
      <div className="plan-info">
        <span className="plan-name">
          {calculatePriceData.plan_title} - {calculatePriceData.duration_title}
        </span>
        <span className="amount">
          {calculatePriceData &&
            convertRialToToman(calculatePriceData.total_amount)}
          <span>تومان</span>
        </span>
      </div>
      {calculatePriceData && (
        <div className="plan-duration">
          {`مدت اعتبار: از تاریخ
          ${formatDateInNumbers(calculatePriceData.start_date)}
           تا
           ${formatDateInNumbers(calculatePriceData.end_date)}
          `}
        </div>
      )}
      <div className="plan-tax">
        {calculatePriceData &&
          calculatePriceData.added_value_percent.toLocaleString()}{" "}
        درصد مالیات بر ارزش افزوده
        <span className="amount">
          {calculatePriceData &&
            convertRialToToman(calculatePriceData.added_value_amount)}
          <span>تومان</span>
        </span>
      </div>
      {calculatePriceData && calculatePriceData.credit_amount > 0 && (
        <div className="amount-row-green">
          <span>استفاده از اعتبار حساب</span>
          <span>
            <span className="amount">{`-${calculatePriceData &&
              convertRialToToman(calculatePriceData.credit_amount)}`}</span>
            <span className="currency">تومان</span>
          </span>
        </div>
      )}
      {calculatePriceData && calculatePriceData.wallet_amount > 0 && (
        <div className="amount-row-green">
          <span>استفاده از امتیاز‌های من</span>
          <span>
            <span className="amount">{`-${calculatePriceData &&
              convertRialToToman(calculatePriceData.wallet_amount)}`}</span>
            <span className="currency">تومان</span>
          </span>
        </div>
      )}
      {calculatePriceData && calculatePriceData.discount_amount > 0 && (
        <div className="amount-row-green">
          <span>
            {calculatePriceData && calculatePriceData.promo_code_text}
          </span>
          <span>
            <span className="amount">{`-${calculatePriceData &&
              convertRialToToman(calculatePriceData.discount_amount)}`}</span>
            <span className="currency">تومان</span>
          </span>
        </div>
      )}
      <AmountBox>
        <div className="amount-row">
          <span>مبلغ قابل پرداخت</span>
          <span>
            <span className="amount">
              {calculatePriceData &&
                convertRialToToman(calculatePriceData.payable_amount)}
            </span>
            <span className="currency">تومان</span>
          </span>
        </div>
      </AmountBox>
    </React.Fragment>
  );
};
